<template>
  <v-container class="d-flex flex-column ga-3">
    <v-row>
      <v-col>
        <UsageExample v-model="tab" :code="code" :tabs="tabs">
          <div class="wrapper">
            <v-container>
              <div class="grid-container">
                <div class="section-title">Examples</div>
                <div class="section-title">Compact</div>
                <div class="section-title">Regular</div>

                <div>Menu from Avatar</div>
                <div>
                  <HxMenu v-slot="props" :items="menuItems" compact @click="menuClick">
                    <v-avatar v-bind="props" color="primary">A</v-avatar>
                  </HxMenu>
                </div>

                <div>
                  <HxMenu v-slot="props" :items="menuItems" @click="menuClick">
                    <v-avatar v-bind="props" color="primary">A</v-avatar>
                  </HxMenu>
                </div>

                <div>Menu from Button</div>
                <div>
                  <HxMenu v-slot="props" :items="menuItems" compact @click="menuClick">
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>
                  <HxMenu v-slot="props" :items="menuItems" @click="menuClick">
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>Menu from Searchbar</div>
                <div style="background-color: white; border-radius: 4px; max-width: 258px">
                  <HxMenu v-slot="props" :items="menuItems" compact @click="menuClick">
                    <HxSearch
                      v-bind="props"
                      search=""
                      placeholder="Search"
                      min-width="150px"
                    ></HxSearch>
                  </HxMenu>
                </div>

                <div style="background-color: white; border-radius: 4px; max-width: 258px">
                  <HxMenu v-slot="props" :items="menuItems" @click="menuClick">
                    <HxSearch
                      v-bind="props"
                      search=""
                      placeholder="Search"
                      min-width="150px"
                    ></HxSearch>
                  </HxMenu>
                </div>

                <div>Menu Items with Icon and Divider</div>
                <div>
                  <HxMenu v-slot="props" :items="menuItemsIconDivider" compact @click="menuClick">
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>
                  <HxMenu v-slot="props" :items="menuItemsIconDivider" @click="menuClick">
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>Menu Items with Long Title (default maxCharacters)</div>
                <div>
                  <HxMenu v-slot="props" :items="menuItemsLongTitle" compact @click="menuClick">
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>
                  <HxMenu
                    v-slot="props"
                    :items="menuItemsLongTitle"
                    tooltip-direction="left"
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>Menu Items with Long Title (specified maxCharacters)</div>
                <div>
                  <HxMenu
                    v-slot="props"
                    :items="menuItemsLongTitle"
                    compact
                    :max-characters="24"
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>
                  <HxMenu
                    v-slot="props"
                    :items="menuItemsLongTitle"
                    :max-characters="24"
                    tooltip-direction="left"
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>Menu with Scroll</div>
                <div>
                  <HxMenu v-slot="props" :items="longMenuItems" compact @click="menuClick">
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>
                  <HxMenu v-slot="props" :items="longMenuItems" @click="menuClick">
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>Menu with Items Indentation</div>
                <div>
                  <HxMenu v-slot="props" :items="menuItemsIndentation" compact @click="menuClick">
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>
                  <HxMenu v-slot="props" :items="menuItemsIndentation" @click="menuClick">
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>
              </div>
            </v-container>
          </div>
        </UsageExample>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixMenus',
  components: { UsageExample },
  setup() {
    const code = `
// Data structure for items prop
const items = [
  {
    title: 'Example 1', // string  -  Menu item display text
    icon: 'mdi-home',   // string  -  MDI icon name (optional)
    hasDivider: true    // boolean -  Show divider below item (optional)
  },
  {
    title: 'Example 2',
    icon: 'mdi-account'
  },
  ....
];

// Menu from Avatar
<HxMenu v-slot="props" :items="menuItems" compact @click="menuClick">
  <v-avatar v-bind="props" color="primary">A</v-avatar>
</HxMenu>

<HxMenu v-slot="props" :items="menuItems" @click="menuClick">
  <v-avatar v-bind="props" color="primary">A</v-avatar>
</HxMenu>

// Menu from Button
<HxMenu v-slot="props" :items="menuItems" compact @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

<HxMenu v-slot="props" :items="menuItems" @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

// Menu from Searchbar
<HxMenu v-slot="props" :items="menuItems" compact @click="menuClick">
  <HxSearch v-bind="props" placeholder="Search with Menu" clearable min-width="200px"></HxSearch>
</HxMenu>

<HxMenu v-slot="props" :items="menuItems" @click="menuClick">
  <HxSearch v-bind="props" placeholder="Search with Menu" clearable min-width="200px"></HxSearch>
</HxMenu>

// Menu Items with Icon and Divider
<HxMenu v-slot="props" :items="menuItemsIconDivider" compact @click="menuClick">
    <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

<HxMenu v-slot="props" :items="menuItemsIconDivider" @click="menuClick">
    <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

// Menu Items with Long Title (default maxCharacters)
<HxMenu v-slot="props" :items="menuItemsLongTitle" compact @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

<HxMenu v-slot="props" :items="menuItemsLongTitle" tooltip-direction="left" @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

// Menu Items with Long Title (specified maxCharacters)
<HxMenu v-slot="props" :items="menuItemsLongTitle" compact :max-characters="24" @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

<HxMenu v-slot="props" :items="menuItemsLongTitle" :max-characters="24" tooltip-direction="left" @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

// Menu with Scroll
<HxMenu v-slot="props" :items="longMenuItems" compact @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

<HxMenu v-slot="props" :items="longMenuItems" @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

// Menu with Items Indentation
<HxMenu v-slot="props" :items="menuItemsIndentation" compact @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

<HxMenu v-slot="props" :items="menuItemsIndentation" @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>
    `;
    return {
      code
    };
  },
  data() {
    return {
      tab: 'Menu Usage',
      tabs: ['Menu Usage'],
      menuItems: [
        { title: 'Go to home' },
        { title: 'Click me 1' },
        { title: 'Click me 2' },
        { title: 'Click me 3' }
      ],
      menuItemsIconDivider: [
        { title: 'Go to home', icon: 'mdi-home', hasDivider: true },
        { title: 'Click me 1', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 2', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 3', icon: 'mdi-cog', hasDivider: false }
      ],
      menuItemsLongTitle: [
        { title: 'Go to home' },
        { title: 'Click me 1 with title longer than default maximum of 49 characters' },
        { title: 'Click me 2 with title longer than default maximum of 49 characters' },
        { title: 'Click me 3 with title longer than default maximum of 49 characters' }
      ],
      longMenuItems: [
        { title: 'Go to home', icon: 'mdi-home', hasDivider: true },
        { title: 'Click me 1', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 2', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 3', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 4', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 5', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 6', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 7', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 8', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 9', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 10', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 11', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 12', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 13', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 14', icon: 'mdi-cog', hasDivider: false }
      ],
      menuItemsIndentation: [
        { title: 'Go to home' },
        { title: '    Click me 1' },
        { title: '    Click me 2' },
        { title: 'Go elsewhere' },
        { title: '    Click me 1' },
        { title: '    Click me 2' }
      ]
    };
  },
  methods: {
    menuClick(_, index) {
      switch (index) {
        case 0:
          this.$router.push('/');
          break;
        default:
          console.log(`Action triggered for menu item ${index + 1}`);
      }
    }
  }
};
</script>

<style scoped>
.wrapper {
  background-color: rgb(238, 238, 238);
}

.section-title {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 1rem;
  margin-top: 1rem;
  display: flex;
  align-items: center;
}

.grid-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 30px;
  padding: 10px;
  align-items: center;
}
</style>
